import { getUserInfo } from '@/request/APIs/logAndSign';
import { createRouter, createWebHashHistory } from 'vue-router';
const requiredModules = require.context('./modules', true, /\.ts$/);
let routes = [{
        path: '/',
        name: 'index',
        redirect: { name: 'login' }
    }];
requiredModules.keys().forEach(fileName => {
    if (fileName === './index.ts')
        return;
    const module = requiredModules(fileName).default || requiredModules(fileName);
    const moduleName = /^\.(\/\w+)\.ts$/g.exec(fileName)[1];
    module.forEach(r => {
        if (r.path) {
            r.path = moduleName + r.path;
        }
    });
    routes = [...routes, ...module];
});
const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: routes
});
router.beforeEach(async (to, from, next) => {
    if (to.name !== 'login') {
        const res = await getUserInfo();
        if (res.code === 1) {
            next();
        }
        else {
            window.location.href = '/#/logAndSign/login';
            return false;
        }
    }
    else {
        next();
    }
});
export default router;
